import { AssistantAvailability } from '../../../../../models/assistantAvailability'
import { AssistanceStatus } from '../../../../../models/assistanceStatus'
import { Assistance } from '../../../../../models/assistance'

interface IAssistantAvailabilitySelectItem {
  availability: AssistantAvailability
  enabled?: boolean
  status?: AssistanceStatus
  flags?: AssistantAvailabilitySelectItemFlag[]
}

export enum AssistantAvailabilitySelectItemFlag {
  IsExchangeAssistance,
}

export class AssistantAvailabilitySelectItem implements IAssistantAvailabilitySelectItem {
  availability: AssistantAvailability
  enabled = true
  status: AssistanceStatus
  flags: AssistantAvailabilitySelectItemFlag[]
  assistanceBefore: Assistance
  assistanceBeforeHHMM: string
  assistanceAfter: Assistance
  assistanceAfterHHMM: string

  constructor(props: IAssistantAvailabilitySelectItem) {
    this.availability = props.availability
    this.enabled = props.enabled
    this.status = props.status
    this.flags = props.flags
  }
}
